import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { AnyIfEmpty } from "react-redux";

export interface ISousModuleDroitState {
  sousModuleDroits: ISousModuleDroit[];
  filteredSousModuleDroits: ISousModuleDroit[];
  sousModuleDroitsByModule: ISousModuleDroit[];
  objSousModuleDroit: ISousModuleDroit;
  openDialog: boolean;
  valueEdit:string;
  valeurComboEdit:string;
}

export interface ISousModuleDroit {
  idModuleDroit: string;
  idSousModuleDroit: string;
  libSousModuleDroit: string;
  createdAt: string;
  updatedAt: string;
}



export const sousModuleDroitSlice: any = createSlice({
  name: "sousModuleDroit",
  initialState: {
    openDialog: false,
    sousModuleDroits: [],
    objSousModuleDroit: {},
    sousModuleDroitsByModule: [],
    filteredSousModuleDroits: [],
    valueEdit:"",
    valeurComboEdit:"",
  },
  reducers: {

    addSousModuleDroits: (state, action) => {
      const newModule: any = [...state.sousModuleDroits, action.payload]
      state.sousModuleDroits = newModule;
    },

    setSousModuleDroits: (state, action) => {
      state.sousModuleDroits = action.payload;
    },

    setObjSousModuleDroit: (state, action) => {
      state.objSousModuleDroit = action.payload;
    },

    setSousModuleDroitsByModule: (state, action) => {
      state.sousModuleDroitsByModule = action.payload;
    },
    setFilteredSousModuleDroits: (state, action) => {
      state.filteredSousModuleDroits = action.payload;
    },

    setOpenDialog: (state, action) => {
      state.openDialog = action.payload;
    },

    deleteSousModuleDroit: (state, action) => {
      state.sousModuleDroits = state.sousModuleDroits.filter((sm: ISousModuleDroit) => sm.idSousModuleDroit !== action.payload);
    },

    editSousModuleDroit: (state, action) => {
      const newModule: any = state.sousModuleDroits.map((sm: ISousModuleDroit) => (sm.idSousModuleDroit === action.payload.idSousModuleDroit ? action.payload : sm))
      state.sousModuleDroits = newModule;
    },

    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },
    setValueComboEdit: (state, action) => {
      state.valeurComboEdit = action.payload;
    },

  }
});

export const {
  addSousModuleDroits,
  setSousModuleDroits,
  setObjSousModuleDroit,
  setSousModuleDroitsByModule,
  setOpenDialog,
  deleteSousModuleDroit,
  editSousModuleDroit,
  setValueEdit,
  setValueComboEdit,
  setFilteredSousModuleDroits
} = sousModuleDroitSlice.actions;


export default sousModuleDroitSlice.reducer;
